// Hero.js
import React from "react";
import { Link } from "react-router-dom";
import heroImage from "../assets/hero-image.jpg";

const Hero = () => {
  return (
    <section className="relative bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center min-h-[600px]">
          {/* Left Content */}
          <div className="px-6 md:px-12 lg:px-16 py-12 lg:py-20">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6">
              We Care for Those You Love,
              <br />
              So You Can Rest Easy
            </h1>

            <p className="text-lg text-gray-700 mb-8 max-w-xl leading-relaxed font-light">
              Allawah Lodge delivers tailored care in the comfort of home,
              empowering your loved ones to maintain their independence while
              providing you with complete peace of mind.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/contact"
                className="bg-[#E85D2C] hover:bg-[#d54d1f] text-white font-medium px-8 py-3.5 rounded-full transition-colors text-center"
              >
                GET CARE NOW
              </Link>
              <Link
                to="/about"
                className="border-2 border-[#E85D2C] text-[#E85D2C] hover:bg-[#E85D2C] hover:text-white font-medium px-8 py-3.5 rounded-full transition-colors text-center"
              >
                LEARN MORE
              </Link>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative h-full min-h-[400px] lg:min-h-[600px]">
            <img
              src={heroImage}
              alt="Compassionate caregiver with elderly woman"
              className="w-full h-full object-cover rounded-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
